import React from 'react'
import { Link } from 'gatsby'

import Header from '../gatsby-theme-docbar/components/header'
import Footer from '../gatsby-theme-docbar/components/footer'

import styles from './index.module.css'

const ThemeIntro = () => (
  <>
    <Header />
    <main className={styles.demoMain}>
      <h1>Welcome to Gatsby-Theme-Docs</h1>
      <p>This is a Gatsby theme for quickly getting a documentation section on your website up and running.</p>
      <p>Navigate over to the <Link to={"/learn"}>learn page</Link> to see the documentation page in action</p>
    </main>
    <Footer />
  </>
)

export default ThemeIntro